import { useApiClientStore } from '../stores/useApiClientStore';
import { ApiResult, PatientDetails } from '../types';

type Body = { ok: true } | { ok: false; errors?: unknown };

const isEmptyObject = (res) => {
  return (
    res.data &&
    typeof res.data === 'object' &&
    !Array.isArray(res.data) &&
    Object.keys(res.data as Record<string, unknown>).length === 0
  );
};

export async function verifyPatientDetailsApi(details: PatientDetails, isProxy: boolean): Promise<ApiResult> {
  const api = useApiClientStore().getClient();

  const res = await api.postRaw<Body>(
    '/patient-portal/session/authenticate-using-patient-details',
    {
      ...details,
      isProxy: isProxy
    },
  );

  if (res.ok) {
    return { ok: true };
  }
  return { ok: false };
}

export async function sendVerificationCodeApi(
  details: PatientDetails,
  transactionId: string,
  isResend: boolean,
): Promise<ApiResult> {
  const api = useApiClientStore().getClient(); // ✅ get actual client

  const res = await api.postRaw<Body>('/patient-portal/send-verification-code', {
    patientDetails: details,
    transactionId,
    isResend,
  });

  if (res.ok) {
    return { ok: true };
  }

  return { ok: false };
}

export async function verifyPatientDetailsAndCodeApi(deps: {
  patientDetails: PatientDetails;
  transactionId: string;
  verificationCode: string;
  setIsVerified: Function;
}): Promise<ApiResult> {
  const api = useApiClientStore().getClient(); // ✅ get actual client
  const res = await api.postRaw<Body>(
    '/patient-portal/session/authenticate-using-patient-details-and-verification-code',
    {
      ...deps.patientDetails,
      transactionId: deps.transactionId,
      verificationCode: deps.verificationCode,
    },
  );

  if (res.ok) {
    deps.setIsVerified(true);
    return { ok: true };
  }

  if(res.data['errors'][0]['code'] === 'incorrect-verification-code-input')
  {
    await api.postRaw<Body>(
      '/patient-portal/record-verification-code-failure-attempt',
      {
        transactionId: deps.transactionId,
      });
  }

  return { ok: false, errors: res.errors };
}

export async function fetchAuthenticatedPatientDetailsApi(): Promise<
  { patientDetails: PatientDetails } | { ok: boolean }
> {
  const api = useApiClientStore().getClient();
  const res = await api.getRaw<{ patientDetails: PatientDetails }>(
    '/patient-portal/session/get-authenticated-patient-details',
  );

  if (!isEmptyObject(res)) {
    return res.data;
  }
  return { ok: false };
}

export async function expireSessionApi(): Promise<{}> {
  const api = useApiClientStore().getClient();
  return await api.postRaw<Body>('/patient-portal/session/expire', {});
}
